export type RandomSource = () => number;

/** Creates the slight, non-zero rotation shared by loose paper visuals. */
export function createNaturalPaperRotation(
  random: RandomSource = Math.random
): number {
  const rotationMagnitude = 0.8 + random() * 2.2;
  const direction = random() < 0.5 ? -1 : 1;
  return Math.round(direction * rotationMagnitude * 10) / 10;
}
